// Profile of Alina Tselinina, Japanese. Source of the profile page.
module.exports = {
  headline: 'AI / Software Engineer • Python, R & AWS',
  summary: 'Alina Tselininaは、データエンジニアリング、応用数学、機械学習のバックグラウンドを持つソフトウェアエンジニアで、現在はAIを活用したアプリケーションとエージェント型システムに取り組んでいます。APIとデータパイプラインの構築、クラウド移行によるアプリケーションのモダナイゼーション、MLを活用したサービスの開発の経験があります。構造化されたワークフロー、統合、テスト、反復的な評価を通じて、LLMとAIエージェントを信頼性の高いソフトウェアシステムに結び付けることに注力しています。',
  imageAlt: 'Alina Tselininaのポートレート',
  personal: {
    languages: '英語、ポーランド語',
    programmingLanguages: 'Python、R、SQL、Bash'
  },
  education: [
    {
      period: '2014年〜2017年',
      field: '専攻：金融数学・保険数理',
      institution: 'Adam Mickiewicz University（アダム・ミツキェヴィチ大学）、ポズナン',
      degree: '学位：修士'
    },
    {
      period: '2009年〜2014年',
      field: '専攻：数学',
      institution: 'Belarusian State University（ベラルーシ国立大学）、ミンスク',
      degree: '学位：学士'
    }
  ],
  skills: [
    {
      title: 'プログラミング',
      description: 'Python、R、SQL、Bash'
    },
    {
      title: 'AIとLLM',
      description: 'Claude、MCP、AIエージェント、LLMの適応、モデルの学習と評価'
    },
    {
      title: 'クラウドとデータ',
      description: 'AWS（Lambda、EC2、S3、Glue、RDS、Athena、Step Functions）、Snowflake'
    },
    {
      title: 'フレームワークとAPI',
      description: 'FastAPI、Flask、Shiny、REST API、Swagger、JSON Schema、Jinja、lxml'
    },
    {
      title: 'データエンジニアリングとDevOps',
      description: 'ETL、Airflow、Docker、Git、Linux、CI/CD'
    },
    {
      title: 'データベースとオーケストレーション',
      description: 'PostgreSQL、Camunda'
    },
    {
      title: 'Atlassianツール',
      description: 'Jira、Bitbucket、Confluence'
    }
  ],
  positions: [
    {
      period: '2026年3月〜現在',
      title: 'AI / Software Engineer、pAIoneer Labs',
      description: [
        'AIエージェントの開発、ワークフローの設定、ツール連携。',
        'LLMの適応、モデルの学習と評価。',
        'AIを活用したアプリケーションの開発と統合。',
        '量子コンピューティング：量子アプリケーション向けソフトウェア開発への貢献。'
      ]
    },
    {
      period: '2025年5月〜現在',
      title: 'Senior Software Developer、Geninvo',
      description: [
        'アプリケーション開発。',
        'アプリケーションの品質を支えるユニットテストおよびUIテストの実装。'
      ]
    },
    {
      period: '2022年11月〜2025年2月',
      title: 'Senior Python Developer、T-Systems',
      description: [
        'データパイプラインとワークフローオーケストレーションの保守と改善。',
        'レポート自動化のためのパッケージ開発。'
      ]
    },
    {
      period: '2022年7月〜2022年10月',
      title: 'Data Engineer、S&P Global',
      description: [
        'ETLパイプラインの開発と保守。'
      ]
    },
    {
      period: '2022年3月〜2022年6月',
      title: 'Python Developer、DevBridge',
      description: [
        'REST APIとバックエンドサービスの設計と開発。',
        'JSONを処理するバックエンドロジックの実装。'
      ]
    },
    {
      period: '2020年11月〜2022年3月',
      title: 'Senior Software Developer、Roche',
      description: [
        'REST APIとバックエンドサービスの設計と開発（概念実証）。',
        'ETLパイプラインの開発と保守。',
        'AWSへの移行とRコードのPythonへの書き換えによるオンプレミスアプリケーションのモダナイゼーション。',
        'XMLの検証とHTMLへの変換。',
        'Webアプリケーションの開発。'
      ]
    },
    {
      period: '2020年5月〜2020年11月',
      title: 'Data Scientist、PSI Polska（ポズナン）',
      description: [
        'バックエンドに機械学習モデルを備えたREST APIとバックエンドサービスの設計と開発。',
        '顧客セグメンテーションモデルの開発。'
      ]
    },
    {
      period: '2019年1月〜2020年4月',
      title: 'Advanced Data Scientist、Analyx（ポズナン）',
      description: [
        'Webスクレイピングとデータパイプラインの開発。',
        'Webアプリケーションの開発。',
        'マーケティング・ミックス・モデリング。',
        'ワークフローの最適化。'
      ]
    },
    {
      period: '2018年5月〜2018年12月',
      title: 'Data Scientist（ポズナン）',
      description: [
        'ETLプロセスの開発。',
        'Bashスクリプトの保守。',
        '顧客サポートとアドホック分析。'
      ]
    },
    {
      period: '2017年4月〜2018年4月',
      title: 'Junior Analyst（ポズナン）',
      description: [
        'データ分析とレポートの作成。',
        'ドキュメントおよびプレゼンテーション資料の作成。'
      ]
    }
  ]
};
